import { useMutation, useQueryClient } from '@tanstack/react-query';
import { generateGeoReport } from '../../../services/geo-report/GeoReportService';
import { useAccount } from '../../../contexts/account/AccountContexts';
import { scheduleIntercomChecklistRefresh } from '../../../services/intercom/trackEvent';
import { GET_GEO_REPORTS, GET_GEO_REPORT_USAGE } from '../../query/geo-report/keys';

export const useGenerateGeoReport = () => {
  const queryClient = useQueryClient();
  const { accountResponse } = useAccount();

  return useMutation({
    mutationFn: (url: string) => generateGeoReport(url),
    onSuccess: (report) => {
      queryClient.invalidateQueries({ queryKey: [GET_GEO_REPORTS] });
      queryClient.invalidateQueries({ queryKey: [GET_GEO_REPORT_USAGE] });
      if (report.status === 'COMPLETED') {
        scheduleIntercomChecklistRefresh(accountResponse);
      }
    },
  });
};
